<template>
    <div class="d-inline">
        <a href="master/conditions" @click="load">
            <slot name="link"></slot>
        </a>
        <div v-if="html"
             @keydown.esc="close"
             class="modal fade bd-example-modal-lg show"
             tabindex="-1"
             role="dialog"
             style="display: block;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{$t('master.conditions.header')}}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                            <span aria-hidden="true"><i class="fa fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body" v-html="html">
                    </div>
                </div>
            </div>
        </div>
        <div v-if="html" class="modal-backdrop fade show" @click="close"></div>
        <LoadingOverlay v-if="loading" class="position-fixed"></LoadingOverlay>
    </div>
</template>
<style scoped lang="scss">
    .modal {
        pointer-events: none;
        .modal-body {
            max-height: 80vh;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>
<script>

    import axios from 'axios';
    import LoadingOverlay from "../LoadingOverlay";

    export default {
        name      : "ConditionsModal",
        components: {
            LoadingOverlay,
        },
        data() {
            return {
                loading: false,
                html: null,
            }
        },
        mounted() {

        },
        methods: {
            close() {
                this.html = null;
                this.loading = false;
            },
            load(e) {
                e.preventDefault();
                this.loading = true;
                axios
                    .get('/master/conditions')
                    .then((res) => {
                        this.html = res.data;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    })
                ;
            }
        }
    }
</script>
